import { LoadingOverlay } from '@/components/core';
import { SidebarProvider } from '@/components/ui-kit/sidebar';
import { Toaster } from '@/components/ui-kit/toaster';
import { useLanguageContext } from '@/i18n/language-context';
import { ClientMiddleware } from '@/state/client-middleware';
import { ThemeProvider } from '@/styles/theme/theme-provider';
import { PurchaseCompleteListener } from '@/modules/subscription/components/PurchaseCompleteListener';
import { Routes } from 'react-router-dom';
import { renderRoutes } from './route-renderer';
import { routesConfig } from './routes.config';
import { useRef } from 'react';

export const AppRoutes = () => {
  const { isLoading } = useLanguageContext();
  const hasRenderedRef = useRef(false);
  if (!isLoading) hasRenderedRef.current = true;

  if (isLoading && !hasRenderedRef.current) {
    return <LoadingOverlay />;
  }
  return (
    <div className="h-full bg-background font-sans antialiased relative">
      <ClientMiddleware>
        <ThemeProvider>
          <SidebarProvider>
            <Routes>
              {renderRoutes(routesConfig)}
            </Routes>
          </SidebarProvider>
        </ThemeProvider>
      </ClientMiddleware>
      <PurchaseCompleteListener />
      <Toaster />
    </div>
  );
};
